<template slot-scope="scope">
  <el-select
    :value="localValue"
    :disabled="disabledFlag"
    @input="$emit('input', $event)"
    placeholder="请选择校区"
    clearable style="width: 100%">
    <el-option v-for="(item,index) in items" :key="index" :label="item.campusName" :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      schoolId: {
        type: String,
        default: '',
      },
      gradationId: {
        type: String,
        default: '',
      },
      disabledFlag: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value(val){
        this.localValue = val
      },
      schoolId(){
        this.query();
      },
      gradationId(){
        this.query();
      }
    },
    data() {
      return {
        localValue: this.value,
        items:[]
      }
    },
    methods: {
      query(){
        let vm = this
        if(!vm.schoolId) return
        // if(!vm.gradationId) return
        http.get(InterfacePrefix['platform'] + "/api/campus?schoolId="+vm.schoolId+"&gradationId="+vm.gradationId+"&status=1").then(function(xhr) {
          if (xhr.data.code) return // 异常情况有公共处理
          vm.items = xhr.data
        })
      }
    },
    mounted() {
      this.query()
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseCampusList.vue